module.exports = __webpack_public_path__ + "static/media/SPECIFY_ID.2abf738d.svg";